import useExperiment from 'utils/useExperiment'
import {
  annualPlan,
  annualPricierPlan,
} from 'checkout/subscription/subscriptionPlans'
import { EXPERIMENTS } from './constants'

const variants = {
  control: {
    annualPlanId: annualPlan.id,
  },
  'treatment-a': {
    hasFreeTrial: true,
    annualPlanId: annualPlan.id,
  },
  'treatment-b': {
    hasFreeTrial: true,
    annualPlanId: annualPricierPlan.id,
  },
  'treatment-c': {
    annualPlanId: annualPricierPlan.id,
  },
}

const useFreeTrialExperiment = () => {
  const { isExperimentReady, variantValue } = useExperiment(
    EXPERIMENTS.freeTrial,
  )

  const variant = variants[variantValue] ?? variants.control

  return {
    isExperimentReady,
    variantValue,
    freeTrialDays: 3,
    experimentId: EXPERIMENTS.freeTrial,
    ...variant,
  }
}

export default useFreeTrialExperiment
